import { useEffect } from 'react';

let lockCount = 0;

/** Disables background scroll while `isOpen` is true. Reference-counted so multiple
 * modals can be open at once without one closing early and unlocking the others. */
export const useLockBodyScroll = (isOpen: boolean) => {
  useEffect(() => {
    if (!isOpen) return;

    lockCount += 1;
    document.body.style.overflow = 'hidden';
    document.body.style.touchAction = 'none';

    return () => {
      lockCount = Math.max(0, lockCount - 1);
      if (lockCount === 0) {
        document.body.style.overflow = '';
        document.body.style.touchAction = '';
      }
    };
  }, [isOpen]);
};

export default useLockBodyScroll;
